import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const TramitacionExternaRow = ({ tramitacion = {}, onUpdate, showHeaderLabels = false }) => { //ya no se pasa onDelete
    const { id, exp, objeto } = tramitacion; //no hace falta pasar ---> fecha_salida_convenio, fecha_firma_convenio, fecha_salida_reso, fecha_firma_reso
    console.log("OBJETO ----->", objeto)

    const handleDateChange = (date, field) => {
        //onUpdate(id, field, date); // Llama a onUpdate con el ID de la fila
        if (!tramitacion) return;

        // Asegurarse de que la fecha se guarde correctamente
        //onUpdate({ ...tramitacion, [field]: date });//original
        onUpdate(id, { [field]: date }); //change
    };

    const handleExpChange = (e) => {
        onUpdate(id, 'exp', e.target.value); // Llama a onUpdate con el ID de la fila
    };

    const handleObjetoChange = (e) => {
        onUpdate(id, 'objeto', e.target.value); // Llama a onUpdate con el ID de la fila
    };

    return (
        <div className="space-y-4 p-4 border rounded bg-white shadow-sm mb-4">            
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
                {/* Campo de Expediente */}
                <div>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`exp-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Expediente
                        </label>
                    )}
                    <input
                        type="text"
                        id={`exp-${id}`}
                        value={exp}
                        onChange={handleExpChange}
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Ej: exp-123"
                        readOnly
                    />
                </div>

                {/* Campo de Objeto, ocultar div --->  style={{ display: 'none' }} */}
                <div style={{ display: 'none' }}>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`objeto-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Objeto
                        </label>
                    )}
                    <input
                        type="text"
                        id={`objeto-${id}`}
                        value={objeto}
                        onChange={handleObjetoChange}
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Ej: objeto-123"
                        readOnly
                    />
                </div>

                {/* Fecha Salida Convenio */}
                <div>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`fecha-salida-convenio-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha salida convenio
                        </label>
                    )}
                    <DatePicker
                        //id={`fecha-salida-convenio-${id}`}
                        selected={tramitacion?.fecha_salida_convenio || null}
                        onChange={(date) => handleDateChange(date, 'fecha_salida_convenio')}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholderText="Seleccionar fecha"
                        isClearable
                    />
                </div>

                {/* Fecha Firma Convenio */}
                <div>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`fecha-firma-convenio-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha firma convenio
                        </label>
                    )}
                    <DatePicker
                        id={`fecha-firma-convenio-${id}`}
                        selected={tramitacion?.fecha_firma_convenio || null}
                        onChange={(date) => handleDateChange(date, 'fecha_firma_convenio')}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholderText="Seleccionar fecha"
                        isClearable
                    />
                </div>

                {/* Fecha Salida Resolución */}
                <div>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`fecha-salida-reso-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha salida resolución
                        </label>
                    )}
                    <DatePicker
                        id={`fecha-salida-reso-${id}`}
                        selected={tramitacion?.fecha_salida_reso || null}
                        onChange={(date) => handleDateChange(date, 'fecha_salida_reso')}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholderText="Seleccionar fecha"
                        isClearable
                    />
                </div>

                {/* Fecha Firma Resolución */}
                <div>
                    {showHeaderLabels && ( // <-- Renderiza el label condicionalmente
                        <label htmlFor={`fecha-firma-reso-${id}`} className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha firma resolución
                        </label>
                    )}
                    <DatePicker
                        id={`fecha-firma-reso-${id}`}
                        selected={tramitacion?.fecha_firma_reso || null}
                        onChange={(date) => handleDateChange(date, 'fecha_firma_reso')}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholderText="Seleccionar fecha"
                        isClearable
                    />
                </div>

                {/* Botón de Eliminar */}
                {/*No hace falta el boton de eliminar, ya que de la longitud del array_obras_expediente en el padre/}
                {/*<div className="flex justify-end">                 
                    <button
                        onClick={() => onDelete(id)} // Llama a onDelete con el ID de la fila
                        className="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
                    >
                        Eliminar
                    </button>
                </div>*/}
            </div>
        </div>
    );
};

export default TramitacionExternaRow;